import React from "react";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="fade-in">
      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-16 lg:pt-24 pb-12">
        <div className="njas-eyebrow">Legal</div>
        <h1 className="njas-display text-6xl sm:text-8xl text-njas-navy mt-4 leading-[0.88]">
          WEBSITE TERMS<br/>&amp; CONDITIONS.
        </h1>
        <p className="mt-6 max-w-3xl text-njas-muted">
          These terms govern your use of the Not Just A Statistic Ltd website. By accessing or using
          this site, you agree to be bound by these terms and Australian Consumer Law (ACL).
        </p>
        <p className="mt-4 text-xs text-njas-muted">Last updated: {new Date().toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}</p>
      </section>

      <section className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-10 pb-24 space-y-14">
        <Term n="01" title="About us" testid="terms-1">
          <p>
            This website is operated by <em className="not-italic">Not Just A Statistic Ltd</em>, a not
            for profit public company limited by guarantee, incorporated in Australia (ABN 65 699 934 515).
            ACNC charity registration details will be published in the footer of this site once available.
          </p>
        </Term>

        <Term n="02" title="Accepting these terms" testid="terms-2">
          <p>
            By using this website you agree to these terms and our{" "}
            <a href="/privacy" className="njas-link text-njas-navy">Privacy Policy</a>. If you do not
            agree, please stop using the site.
          </p>
        </Term>

        <Term n="03" title="Use of the website" testid="terms-3">
          <p>You agree to use this website only for lawful purposes. You must not:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>use the site in any way that breaches applicable local, national or international law;</li>
            <li>attempt to gain unauthorised access to any part of the site or our systems;</li>
            <li>use the site to transmit any material that is unlawful, defamatory, obscene or harmful;</li>
            <li>interfere with any other person's use of the site.</li>
          </ul>
        </Term>

        <Term n="04" title="Referrals, forms &amp; user submitted content" testid="terms-4">
          <p>
            By submitting a referral, volunteer application, membership application, contact form or
            other information, you confirm that the information is accurate to the best of your
            knowledge and that you have appropriate consent to share information about any third
            party (for example, a client if you are a third party referrer).
          </p>
          <p>
            Information you submit is handled in accordance with our{" "}
            <a href="/privacy" className="njas-link text-njas-navy">Privacy Policy</a>.
          </p>
        </Term>

        <Term n="05" title="Staff portal &amp; login accounts" testid="terms-5">
          <p>
            Access to the Staff Portal is restricted to authorised NJAS staff, volunteers and
            directors. You must not share your login credentials, and you must notify us immediately
            if you suspect unauthorised access to your account.
          </p>
        </Term>

        <Term n="06" title="Donations" testid="terms-6">
          <p>
            When online giving is enabled, donations will be processed by a secure third party payment
            gateway. Refer to our{" "}
            <a href="/get-involved#donate" className="njas-link text-njas-navy">Donation Page</a> for
            tax deductibility status, fundraising authority details, receipting information and refund
            policy at the point of payment.
          </p>
        </Term>

        <Term n="07" title="Intellectual property" testid="terms-7">
          <p>
            All content on this website, including the NJAS name, logo, imagery and written material,
            is owned by or licensed to Not Just A Statistic Ltd. You may view and share content for
            personal, non commercial purposes with attribution, but may not reproduce it commercially
            without our written permission.
          </p>
        </Term>

        <Term n="08" title="External links &amp; third party services" testid="terms-8">
          <p>
            This website may contain links to external websites and services (for example, crisis
            hotlines and payment processors). We are not responsible for the content, practices or
            availability of any external site.
          </p>
        </Term>

        <Term n="09" title="Disclaimer &amp; consumer guarantees" testid="terms-9">
          <p>
            Information on this website is provided in good faith for general information purposes
            only and does not constitute legal, medical, mental health or financial advice. If you
            require professional advice you should contact a suitably qualified practitioner.
          </p>
          <p>
            Nothing in these terms excludes, restricts or modifies any consumer guarantee, right or
            remedy under the Australian Consumer Law that cannot be lawfully excluded.
          </p>
        </Term>

        <Term n="10" title="Changes to these terms" testid="terms-10">
          <p>
            We may update these terms from time to time. The most recent version will always be
            available on this page.
          </p>
        </Term>

        <Term n="11" title="Contact" testid="terms-11">
          <p>
            Questions about these terms should be sent to{" "}
            <a className="njas-link text-njas-navy" href="mailto:info@njas.org.au">info@njas.org.au</a>.
          </p>
        </Term>
      </section>
    </div>
  );
}

function Term({ n, title, children, testid }) {
  return (
    <article className="grid grid-cols-12 gap-6" data-testid={testid}>
      <div className="col-span-2 njas-display text-4xl text-njas-sage">{n}</div>
      <div className="col-span-10">
        <h2 className="njas-display text-3xl sm:text-4xl text-njas-navy leading-tight" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="mt-4 space-y-4 text-njas-text leading-relaxed">{children}</div>
      </div>
    </article>
  );
}
